import { useRef } from 'react';
import { SelectMenuHandle } from '../SelectMenu';
import { useMenuOptions } from '../SelectMenuOptions';
import { MultiSelectMenuOptions, MultiSelectMenuOptionsProps } from './MultiSelectMenuOptions';

export function useMultiSelectMenuOptions<T>(props: MultiSelectMenuOptionsProps<T>) {
  const { options, ...rest } = props;
  const sortedOptions = useMenuOptions(options);
  const optionsRef = useRef<SelectMenuHandle>(null);
  const optionsProps: MultiSelectMenuOptionsProps<T> = {
    ...rest,
    options: sortedOptions,
    innerRef: optionsRef,
  };

  return {
    optionsProps,
    Options: MultiSelectMenuOptions,
  };
}
